<template>
    <div class="validation-container">
        <div class="validation-header">
			<i class="fas fa-times" v-on:click="onClose" />
		</div>
        <div class="validation-steps" v-if="userStatusId == 1"> <!-- Novo afiliado -->
            <div class="validation-intro">
                <i class="fas fa-award" />
                <h4>Parabéns!</h4>
                <p>Agora que você possui um saldo acima de {{ withdrawMin | fmtMoney }} você poderá sacar seu saldo.</p>
                <h5>Mas antes você precisá validar sua identidade para sua segurança.</h5>

                <button class="button" v-on:click="next">
                    Fazer validação
                </button>
            </div>
            <div class="validation-files">
                <div class="validation-files-content">
                    <h4>Envio de arquivos</h4>
                    <p>Anexe os arquivos necessários para que seja feita validação.</p>
                    <div class="file-list">
                        <div :class="document.file ? 'file-item document selected' : 'file-item document'" :key="document.id" v-on:click="clickToSendFile" v-for="document in documents">
                            <i class="fas fa-file-alt" v-if="!document.file" />
                            <i class="fas fa-check" v-else />
                            <p>{{ document.title }}</p>
                            <input class="document" type="file" accept="image/png, image/jpeg" :name="`${document.name}-${document.id}`" v-on:change="setFile($event, `${document.name}-${document.id}`)" />
                        </div>
                    </div>
                </div>
                <button class="button send-files" :disabled="!documents.every(document => document.file) || validationLoading" v-on:click="validate(documents)">
                    <v-progress-circular v-if="validationLoading" color="white" size="16" indeterminate="indeterminate"></v-progress-circular>
                    <p>{{ validationLoading ? 'Enviando...' : 'Enviar documentos' }}</p>
                </button>
            </div>
        </div>
        <div class="validation-pending" v-if="userStatusId == 3">
            <div class="validation-files">
                <div class="validation-files-content">
                    <h4>Status Pendente</h4>
                    <p>{{ statusNotes }}</p>
                    <div class="file-list">
                        <div :class="document.file ? 'file-item document selected' : 'file-item document'" :key="document.id" v-on:click="clickToSendFile" v-for="document in documents">
                            <i class="fas fa-file-alt" v-if="!document.file" />
                            <i class="fas fa-check" v-else />
                            <p>{{ document.title }}</p>
                            <input class="document" type="file" accept="image/png, image/jpeg" :name="`${document.name}-${document.id}`" v-on:change="setFile($event, `${document.name}-${document.id}`)" />
                        </div>
                    </div>
                </div>
                <button class="button send-files" :disabled="!documents.every(document => document.file) || validationLoading" v-on:click="validate(documents)">
                    <v-progress-circular v-if="validationLoading" color="white" size="16" indeterminate="indeterminate"></v-progress-circular>
                    <p>{{ validationLoading ? 'Enviando...' : 'Enviar novamente' }}</p>
                </button>
            </div>
        </div>
        <div class="validation-loading" v-if="userStatusId == 4"> <!-- Validando -->
            <i class="fas fa-user-clock" />
            <h4>Aguarde a Validação</h4>
            <p>Seus documentos serão validados por nossa equipe em até 2 dias úteis.</p>

            <div class="validation-loading-footer">
                <p v-on:click="onClose">Fechar</p>
            </div>
        </div>
    </div>
</template>

<script>
import AFileUpload from './AFileUpload.vue';
export default {
    components: {
        AFileUpload
    },

    data() {
        return {
            validationLoading: false,
            documents: [
                {
                    id: 1,
                    name: 'rg',
                    title: 'RG (Frente)',
                    file: null,
                },
                {
                    id: 2,
                    name: 'rg',
                    title: 'RG (Verso)',
                    file: null,
                },
                {
                    id: 3,
                    name: 'address',
                    title: 'Comprovante de Residencia',
                    file: null,
                }
            ]
        }
    },

    props: {
        onClose: {
            type: Function,
            required: true
        },
        userStatusId: {
            type: Number,
            required: true
        },
        statusNotes: {
            type: String
        },
        onValidate: {
            type: Function,
            required: true
        },
        withdrawMin: {
            type: Number,
            required: true
        }
    },

    methods: {
        next() {
            document.querySelector('.validation-steps').scrollTo({ top: document.querySelector('.validation-steps').clientHeight, behavior: 'smooth' });
        },

        clickToSendFile(e) {
            if (e.target.classList.contains('document')) {
                if (e.target.querySelector('.document') != null)
                    e.target.querySelector('.document').click();
            } else {
                e.target.parentElement.querySelector('.document').click();
            }
        },

        setFile(e, document) {
            this.documents.find(doc => `${doc.name}-${doc.id}` == document).file = e.target.files[0];
        },

        async validate(documents) {
            this.validationLoading = true;
            try{
                await this.onValidate(documents);
            }catch(err){
                this.$notifyUser({
					type: 'error',
					message: 'Ocorreu um erro ao enviar os arquivos! Tente novamente mais tarde.'
				});
            }
            this.validationLoading = false;
        }
    },
}
</script>

<style scoped>
    p {
        margin: 0;
    }

    .validation-container {
        width: auto;
        max-height: 550px;
        background-color: var(--background-color);
        border-radius: 10px;
        padding: 20px;
        overflow: auto;
        position: relative;
    }

    .validation-steps {
        height: 320px;
        overflow: hidden;
        flex: 1;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
    }

    .validation-intro {
        width: 100%;
        height: 320px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex: 0;
        scroll-snap-align: start;
    }

    .validation-intro > i {
        font-size: 50px;
        color: var(--primary-color);
    }

    .validation-intro > h4 {
        font-size: 20px;
        font-weight: bold;
        color: var(--black-color);
        margin-top: 15px;
        text-align: center;
    }

    .validation-intro > h5 {
        font-size: 18px;
        color: var(--primary-color);
        text-align: center;
        font-weight: bold;
        margin-bottom: 25px;
    }

    .validation-intro > p {
        font-size: 16px;
        color: #555;
        width: 75%;
        text-align: center;
        margin-bottom: 20px;
    }

    .validation-loading, .validation-pending {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
    }

    .validation-loading > i {
        font-size: 60px;
        color: var(--primary-color);
        margin-bottom: 20px;
    }

    .validation-loading > h4 {
        font-weight: bold;
        color: var(--black-color);
    }

    .validation-loading > p {
        color: #555;
        margin-bottom: 20px;
        text-align: center;
    }

    .validation-loading-footer {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        
    }

    .validation-loading-footer > p {
        font-size: 18px;
        color: var(--primary-color-hover);
        font-weight: bold;
        cursor: pointer;
    }

    .button {
        width: auto;
        padding: 7px 20px;
        border-radius: 5px;
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
        cursor: pointer;
        transition: 0.2s;
        user-select: none;
        font-weight: bold;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--secondary-color);
    }

    button:disabled {
        background-color: #555;
        color: #fff;
        cursor: not-allowed;
    }

    .validation-files {
        padding: 20px;
        padding-top: 0;
        width: 100%;
        height: 320px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .validation-files .send-files {
        display: flex;
        align-self: flex-end;
        flex-direction: row;
        align-items: center;
    }

    .validation-files .send-files > .v-progress-circular {
        margin-right: 10px;
    }

    .validation-files h4 {
        font-size: 24px;
        font-weight: bold;
        color: var(--primary-color);
    }

    .validation-files-content > p {
        font-size: 16px;
        color: #555;
        margin-bottom: 20px;
        color: var(--black-color);
        width: 75%;
    }

    .file-list {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100px;
        gap: 20px;
    }

    .file-item {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        flex: 1;
        border: 3px dashed var(--neutral-color);
        padding: 15px;
        cursor: pointer;
        transition: .2s;
    }

    .file-item.document.selected {
        border: 3px solid var(--success-color);
    }

    .file-item:hover {
        border-color: var(--primary-color);
    }

    .file-item > i {
        font-size: 25px;
        color: var(--neutral-color);
        margin-bottom: 5px;
    }

    .file-item.document.selected > i {
        color: var(--success-color);
    }

    .file-item:hover > i {
        color: var(--primary-color);
    }

    .file-item > p {
        font-size: 16px;
        color: var(--neutral-color);
        font-weight: bold;
    }

    .file-item.document.selected > p {
        color: var(--success-color);
    }

    .file-item:hover > p {
        color: var(--black-color);
    }


    .validation-header {
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }

    .validation-header > i {
        font-size: 22px;
        cursor: pointer;
    }

    .validation-header > h4,
    .validation-header > i {
        color: var(--primary-color);
        font-weight: bold;
    }

    input[type=file] {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/ValidationModal.vue